import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import moment from 'moment';
import { propOr, compose, ifElse, equals, curry, map } from 'ramda';
import { featureForRoute } from '../shared/lib/feature-for-path';
import { setRouteName } from './App/redux/actions';

const LOGIN_PATH = '/account/login';

@connect(state => ({
  user: state.Account.user,
  deletedAccount: state.Account.deletedAccount,
  routeName: state.App.routeName,
}))
export default class RouteWrapper extends Component {
  static propTypes = {
    component: PropTypes.any.isRequired,
    deletedAccount: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.object,
    match: PropTypes.object,
    computedMatch: PropTypes.object,
    name: PropTypes.string,
    onEnter: PropTypes.array,
    routeName: PropTypes.string,
    user: PropTypes.object,
  };

  componentDidMount() {
    this.didNavigate(this.props);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.didNavigate(this.props);
    }
  }

  updateRouteName(props) {
    const oldName = props.routeName;
    const currentName = props.name;
    currentName && currentName !== oldName && this.props.dispatch(setRouteName(currentName));
  }

  didNavigate(props) {
    window.scrollTo(0, 0);
    this.updateRouteName(props);
  }

  userHas = (props, field) => (props.user && props.user[field]);

  requireActiveSubscription = (props) => {
    const { user, match } = props;
    const { path } = match;
    const protectedFeature = featureForRoute(path);
    const subscriptionLevel = propOr(0, 'subscriptionLevel');
    const hasActiveSubscription = propOr(false, 'subscriptionActive');
    const isUserInvalid = () => !hasActiveSubscription(user);
    const isUserLevelLess = () => subscriptionLevel(user) < protectedFeature.level;

    const isUserLevelInvalid = ifElse(
      equals(true),
      () => true,
      isUserLevelLess,
    );

    const shouldRedirect = compose(
      isUserLevelInvalid,
      isUserInvalid,
    );

    const protectedPaths = {
      'flight-alerts': '/flight-alerts/subscribe',
      'departing-arriving': '/airports/departing-arriving/subscribe',
      'historical-flight': '/historical-flight/subscribe',
    };

    const foundPathKey = Object.keys(protectedPaths).filter(name => path.includes(name));

    return shouldRedirect(user) ? protectedPaths[foundPathKey] || '/subscription' : '';
  }

  requireLogin = props => (props.user || props.deletedAccount ? '' : LOGIN_PATH);

  requireSignUp = props => (this.userHas(props, 'email') ? '' : '/register/plan');

  requireVerifiedEmail = props => (this.userHas(props, 'verified') ? '' : '/account/verify');

  validateHistoricalDate = (props) => {
    const { params } = props.match;

    if (params) {
      const { year, month, day } = params;
      if (year && month && day) {
        const dayString = Number(day) < 10 ? `0${Number(day)}` : day;
        const monthString = Number(month) < 10 ? `0${Number(month)}` : month;
        const now = moment();
        const dateSearched = `${year}-${monthString}-${dayString}`;
        const validHistorical = () => moment(dateSearched).isSameOrBefore(now, 'date');
        const valid = validHistorical();

        if (!valid) {
          return '/historical-flight?error=FLIGHT_LOAD_ERROR2';
        }

        return '';
      }
    }
  }

  validateTrackerDate = (props) => {
    const { params } = props.match;

    if (params) {
      const { year, month, day } = params;
      if (year && month && day) {
        const dayString = Number(day) < 10 ? `0${Number(day)}` : day;
        const monthString = Number(month) < 10 ? `0${Number(month)}` : month;
        const now = moment();
        const dateSearched = `${year}-${monthString}-${dayString}`;
        // in the last three days for extended details
        const validTrackerDetails = () => {
          const fourDaysAgo = moment(now).subtract(4, 'days');

          return moment(dateSearched).isAfter(fourDaysAgo, 'date');
        };
        const valid = validTrackerDetails();

        if (!valid) {
          return '/flight-tracker/search?error=FLIGHT_LOAD_ERROR2';
        }

        return '';
      }
    }
  }

  mapConstToFunc = {
    requireActiveSubscription: this.requireActiveSubscription,
    requireLogin: this.requireLogin,
    requireSignUp: this.requireSignUp,
    requireVerifiedEmail: this.requireVerifiedEmail,
    validateHistoricalDate: this.validateHistoricalDate,
    validateTrackerDate: this.validateTrackerDate,
  }

  applyFuncs = (validators, props) => curry(fns => map((fn) => {
    if (typeof fn !== 'function') {
      throw new Error(`onEnter handler missing: ${fn}`);
    }
    return fn(props);
  }, fns))(validators);

  render() {
    const { onEnter = [], component: TargetComponent, ...rest } = this.props;

    return (
      <Route
        {...rest}
        render={(props) => {
          const {
            deletedAccount,
            user,
          } = this.props;
          const fns = onEnter.map(fnName => this.mapConstToFunc[fnName] || fnName);
          const validatorProps = {
            user,
            deletedAccount,
            ...props,
          };
          const appliedFns = onEnter.length ? this.applyFuncs(fns, validatorProps) : [];
          const redirTo = appliedFns.filter(f => f).find(g => g);

          if (redirTo) {
            return (
              <Redirect to={{
                pathname: redirTo,
                state: { from: props.location },
              }}
              />
            );
          }

          return <TargetComponent {...props} {...rest} />;
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./modules/RouteWrapper.js